// extracted by mini-css-extract-plugin
module.exports = {"emailInput":"_1ggNP","invalid":"_2oEKP"};